import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { FavouriteSearchData } from './types-store';
import { FavouriteSearchWire } from './types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

export const mapList = (listWire: FavouriteSearchWire[]): FavouriteSearchData[] => {

  if ((listWire?.length ?? 0) === 0) {
    return [];
  }

  return listWire.map(item => ({
    ...(isDefinedIncludingZero(item.code?.v)
      && {
      code: {
        value: item.code?.v,
        description: item.code?.d,
        codeExtra: item.code?.c
      }
    }),
    ...(isDefinedIncludingZero(item.owner?.v)
      && {
      owner: {
        value: item.owner?.v,
        description: item.owner?.d
      }
    }),
    ...(isDefinedIncludingZero(item.parent?.v)
      && {
      parent: {
        value: item.parent?.v,
        description: item.parent?.d
      }
    }),
    disabled: parseAsDateUTC(item.disabled),
    shared: !!item.shared,
    invalidOwner: !!item.invalidOwner
  }));
};
